import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'myContactsFilter'
})

export class ContactsFilterPipe implements PipeTransform {
  public transform(items: any[], searchText: string, searchField: string, searchField1 = null): any[] {
    if (!items) { return []; }
    if (!searchText || searchText.trim().length === 0) { return items; }
  
    const trimmedSearchText = searchText.trim().toLowerCase(); 
  
    if (searchField1) {
      return items.filter((it) => {
        if (it[searchField1]) {
          return (
            it[searchField] && it[searchField].toLowerCase().includes(trimmedSearchText) ||
            it[searchField1] && it[searchField1].toLowerCase().includes(trimmedSearchText)
          );
        } else {
          return it[searchField] && it[searchField].toLowerCase().includes(trimmedSearchText);
        }
      });
    } else {
      return items.filter((it) => {
        return it[searchField] && it[searchField].toLowerCase().includes(trimmedSearchText);
      });
    }
  }
  
}
